module.exports = __webpack_public_path__ + "static/media/mediaexposure.21af5de9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/ProgramTimeline/img/mediaexposure.svg
// module id = 237
// module chunks = 0